<template>
  <div class="vz-light-order-steps">
    <div class="vz-light-order-steps-progress">
      <template v-for="(step, i) of steps">
        <div
          v-if="i !== 0"
          class="vz-light-order-steps-progress-path"
          :class="lightOrderStep >= i ? 'bg-primary' : 'bg-border-gray'"
        />
        <vz-icon
          no-masked-icon
          url="/svg/icon/vz-ellipse.svg"
          :title="step"
          :variant="lightOrderStep >= i ? 'primary' : 'inactive'"
        />
      </template>
    </div>
    <div class="vz-light-order-steps-title mt-10">
      {{ stepName }}
    </div>
  </div>
</template>

<script setup lang="ts">
import {storeToRefs} from 'pinia';
import {useOrderStore} from '~/stores/order';
import VzIcon from '~/components/ui-kit/vz-icon.vue';

const { lightOrderStep } = storeToRefs(useOrderStore())

const steps = ['Направление', 'Груз', 'Участники', 'Подтверждение']

const stepName = computed(() => {
  return steps[lightOrderStep.value] || ''
})

</script>

<style lang="scss" scoped>
.vz-light-order-steps {
  width: 100%;
  margin-top: 20px;

  &-title {
    color: $primary;
    font-size: $fs-20;
    font-weight: 500;
    text-transform: uppercase;
  }

  &-progress {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &-path {
      height: 6px;
      flex-grow: 1;
      margin: 0 5px;
    }
  }
}
</style>
